<template>
    <transition name="fade" mode="out-in">
        <router-view></router-view>
    </transition>
</template>

<script>
    import {HTTP} from "@/utils/http";
    import store from "@/store/index.js";
    import Apis from "@/apis/index";
    import Enums from "@/apis/_enums";
    import {mapState} from "vuex";

    export default {
        name: "BoxDetailsMaster",
        mounted() {
            this.stationUid = this.$route.params.stationUid;
            this.clockUid = this.$route.params.boxUid;
            this.loadBox();
        },
        computed: {
            ...mapState({
                isConstraintModified: state => state.isConstraintModified
            })
        },
        beforeRouteUpdate(to, from, next) {
            if (!!this.isConstraintModified) {
                const message = confirm("Are you sure you want to exit ? Some changes aren\'t saved")
                if (message) {
                    this.$store.commit('setStatusConstraint', false)
                    next()
                }
            } else {
                next()
            }
        },
        watch: {
            $route: function (to, from) {
                this.stationUid = this.$route.params.stationUid;
                this.boxUid = this.$route.params.boxUid;
                this.loadBox();
            }
        },
        methods: {
            startDeleteBox(box) {
                EventBus.$emit("onTrackFromBoxDelete", box);
            },
            loadBox: function () {
                // console.log("Parameters for loading Box : ", this.$route.params);
                if (
                    this.$route.params != null &&
                    this.$route.params.stationUid != null &&
                    this.$route.params.boxUid != null
                ) {
                    store.dispatch("loadBox", this.$route.params);
                }
            }
        }
    };
</script>